import { Drawer, Menu } from 'antd';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setLanguage } from 'redux-polyglot/dist/actions';
import actions from 'redux/settings/actions';
import FooterLayout from './footer';
import HeaderLayout from './header';

const Layout = ({ children }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { phrases } = useSelector(({ polyglot }) => polyglot)

  const { isMobileMenuOpen } = useSelector(({ settings }) => settings)
  const { locale } = useSelector(({ polyglot }) => polyglot)

  const [current, setCurrent] = useState('');

  useEffect(() => {
    const lang = localStorage.getItem('lang');
    if (lang) {
      const translate = require(`lang/${lang}.json`);
      dispatch(setLanguage(lang, translate))
    } else {
      localStorage.setItem('lang', 'en')
      const translate = require(`lang/en.json`);
      dispatch(setLanguage('en', translate))
    }

  }, [dispatch])

  const handleLang = (lang) => {
    localStorage.setItem('lang', lang)
    const translate = require(`lang/${lang}.json`);
    dispatch(setLanguage(lang, translate))
  }

  const onClick = async (e) => {
    await setCurrent(e.key);
    await navigate(e.key)
    await onClose()
  };

  const onClose = () => {
    dispatch({
      type: actions.HANDLE_STATE,
      field: 'isMobileMenuOpen',
      value: !isMobileMenuOpen
    })
  }

  if (phrases) {
    const {
      components: { nav, header }
    } = phrases

    const items = [
      {
        label: header.home,
        key: '/',
        children: false,
      },
      {
        label: nav.aboutUs.aboutUs,
        key: '/tentang-kami',
        children: [
          {
            label: nav.aboutUs.companyProfile,
            key: '/profil-perusahaan',
            children: false
          },
          {
            label: nav.aboutUs.companyStructure,
            key: '/struktur-perusahaan',
            children: [
              {
                label: nav.aboutUs.boardOfCommissioners,
                key: '/struktur-perusahaan/dewan-komisaris',
                children: false
              },
              {
                label: nav.aboutUs.boardOfDirectors,
                key: '/struktur-perusahaan/direksi',
                children: false
              },
              {
                label: nav.aboutUs.organizationalStructure,
                key: '/struktur-perusahaan/struktur-organisasi',
                children: false
              },

            ]
          },
          {
            label: nav.aboutUs.career,
            key: '/karir',
            children: false
          },
          {
            label: nav.aboutUs.contactUs,
            key: '/hubungi-kami',
            children: false
          },
        ]
      },
      {
        label: nav.ourBusiness,
        key: '/usaha-kami',
        children: false,
      },
      {
        label: nav.governance.governance,
        key: '/tata-kelola',
        children: [
          {
            label: nav.governance.rups,
            key: '/tata-kelola/rups',
            children: false
          },
          // {
          //   label: nav.governance.publicExposure,
          //   key: '/tata-kelola/paparan-publik',
          //   children: false
          // },
          {
            label: nav.aboutUs.charter,
            key: '/tata-kelola/piagam',
            children: false
          },
          // {
          //   label: nav.governance.complaint,
          //   key: '/tata-kelola/pengaduan',
          //   children: false
          // },
          // {
          //   label: nav.governance.publicBudget,
          //   key: '/tata-kelola/anggaran-publik',
          //   children: false
          // },
          // {
          //   label: nav.governance.sustainabilityReport,
          //   key: '/tata-kelola/laporan-keberlanjutan',
          //   children: false
          // },
        ]
      },
      {
        label: nav.investorRelations.investorRelations,
        key: '/hubungan-investor',
        children: [
          {
            label: nav.investorRelations.Prospectus,
            key: '/hubungan-investor/prospektus',
            children: false
          },
          {
            label: nav.investorRelations.information,
            key: '/hubungan-investor/informasi',
            children: false
          },
          {
            label: nav.investorRelations.summary,
            key: '/hubungan-investor/ringkasan-keuangan',
            children: false
          },
          {
            label: nav.investorRelations.financialStatements,
            key: '/hubungan-investor/laporan-keuangan',
            children: false
          },
          {
            label: nav.investorRelations.annualReport,
            key: '/hubungan-investor/laporan-tahunan',
            children: false
          },
          {
            label: nav.investorRelations.shareholderInformation,
            key: '/hubungan-investor/informasi-pemegang-saham',
            children: false
          },
          {
            label: nav.investorRelations.stockInformation,
            key: '/hubungan-investor/informasi-saham',
            children: false
          },
          {
            label: nav.investorRelations.dividend,
            key: '/hubungan-investor/dividen',
            children: false
          },

        ]
      },
      {
        label: nav.socialResponsibility,
        key: '/kepedulian-sosial',
        children: false
      },
      {
        label: header.newsAndArticle,
        key: '/artikel',
        children: false,
      },
    ]

    const lang = (
      <div className='lang'>
        {
          locale === 'id' &&
          <button onClick={() => handleLang('en')}>
            <img src='/images/assets/icons/lang-en.png' alt='EN' />
          </button>
        }
        {
          locale === 'en' &&
          <button onClick={() => handleLang('id')}>
            <img src='/images/assets/icons/lang-id.png' alt='ID' />
          </button>
        }
      </div>
    )

    return (
      <>
        <Drawer
          title="Menu"
          placement='left'
          closable={false}
          onClose={onClose}
          visible={isMobileMenuOpen}
          className='mpx-nav--side'
          extra={lang}
        >
          <Menu
            onClick={onClick}
            style={{
              width: '100%',
            }}
            selectedKeys={[current]}
            mode="inline"
            className='nav-list'
            items={items}
          />
        </Drawer>
        <HeaderLayout />
        {children}
        <FooterLayout />
      </>
    );
  } else {
    return false
  }
}

export default Layout;